import React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import StudyStreakIcon from '../../Achievements/StudyStreakIcon';

/**
 * StudyNavbar
 * Top chrome of the study experience.
 *
 * Renders: snippet icon · breadcrumb (cookbook › section) · streak.
 */
const StudyNavbar = ({
  snippetIcon,
  cookbookName,
  sectionName,
  streak,
  controls = null,
}) => {
  return (
    <div className="study-shell__navbar">
      {snippetIcon && (
        <span className="study-shell__navbar-snippet-icon" aria-hidden="true">
          {snippetIcon}
        </span>
      )}
      {snippetIcon && (cookbookName || sectionName) && (
        <span className="study-shell__navbar-separator" aria-hidden="true" />
      )}
      {cookbookName && (
        <span className="study-shell__navbar-cookbook">{cookbookName}</span>
      )}
      {cookbookName && sectionName && (
        <FaChevronRight
          className="study-shell__navbar-breadcrumb-chevron"
          aria-hidden="true"
        />
      )}
      {sectionName && (
        <span className="study-shell__navbar-section">{sectionName}</span>
      )}

      <div className="study-shell__navbar-right">
        {controls}
        {typeof streak === 'number' && streak > 0 && (
          <span
            className="study-shell__navbar-meta-item study-shell__navbar-meta-item--streak"
            title={`Current study streak: ${streak}`}
          >
            <StudyStreakIcon
              className="study-shell__navbar-meta-icon study-shell__navbar-meta-icon--streak"
              active
              aria-hidden="true"
            />
            <span>{streak}</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default StudyNavbar;
